import React, { FC } from "react";
import clsx from "clsx";

import { TNameStatus } from "../../../../state";

import styles from "./Badge.module.scss";

type Props = {
  isArchived: boolean;
  nameStatus: TNameStatus;
  isSubmissionPrivate: boolean;
};

const Badge: FC<Props> = ({ isArchived, nameStatus, isSubmissionPrivate }) => {
  return (
    <div className={styles.badgeBlock}>
      {isArchived && <span className={styles.badge}>提出終了</span>}
      {nameStatus === "unpublish" && (
        <span className={styles.badge}>匿名共有</span>
      )}
      {isSubmissionPrivate && (
        <span className={clsx(styles.badge, styles.blueBadge)}>非共有BOX</span>
      )}
    </div>
  );
};

export default Badge;
